// src/context/UserContext.jsx
import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState(''); // user = { userName, userEmail }
  const [userName, setuserName] = useState(''); // user = { userName, userEmail }
  const [apps,setApps]=useState([]);

  return (
    <UserContext.Provider value={{ userEmail, setUserEmail,userName,setuserName,apps,setApps }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
